import { useEffect as e, useState as t } from "react";
//#region src/lib/useIsMobile.ts
function n() {
	let [n, r] = t(() => window.matchMedia("(max-width: 767px)").matches);
	return e(() => {
		let e = window.matchMedia("(max-width: 767px)");
		r(e.matches);
		let t = (e) => r(e.matches);
		return e.addEventListener("change", t), () => e.removeEventListener("change", t);
	}, []), n;
}
//#endregion
export { n as useIsMobile };

//# sourceMappingURL=useIsMobile.js.map